import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'

import type { RouteLocationNormalizedLoaded } from 'vue-router'
import type { EntryFieldTypes } from 'contentful'
import type { TypeCallToActionWithoutUnresolvableLinksResponse } from '~/types/contentful'

type JsonField = EntryFieldTypes.Object

function dataType(data: string | JsonField | object | [] | undefined | null) {
  switch (true) {
    case typeof data === 'string':
      return 'string'
    case isObject(data):
      return 'object'
    case isArray(data):
      return 'array'
    default:
      return 'unknown'
  }
}

export default function ctaWithConfigOverride(
  cta: TypeCallToActionWithoutUnresolvableLinksResponse | undefined,
  route: RouteLocationNormalizedLoaded,
) {
  if (!cta) return undefined
  // Allows custom field overrides per page route. Example: `{ "marketing-materials": { "label": "Download Marketing Material" } }`
  if (dataType(cta?.fields?.configOverride) !== 'object') {
    return cta
  } else {
    const configOverride = cta?.fields?.configOverride as {
      [key: string]: TypeCallToActionWithoutUnresolvableLinksResponse['fields']
    }
    const path = arrayAsString(route.params.slug) || ''
    const routeConfigOverride = configOverride?.[path]
    return {
      sys: cta?.sys,
      fields: {
        ...cta?.fields,
        ...routeConfigOverride,
      },
      metadata: cta?.metadata,
    }
  }
}
